import { ChevronDownIcon } from "@heroicons/react/24/outline";
import Image from "src/components/elements/Image";
import { isSVGString } from "src/helpers";
import { classNames } from "src/helpers/classNames";
import TopMenuItemLink from "./TopMenuItemLink";

const TopMenuItemGroupTitle = ({ data, imageClassName, setImageClassName, group_id, page_id, isUnderLine, avoidUnderlineHover = false, searchTerm, handleClick = () => {}, clickMainMenu = () => {}, windowWidth = 0, dropdownArrowClass, mordernDesign }) => {
  return (
    <>
      {data.submenu.length > 1 || data.subMenuFilteredDown ? (
        <button
          type="button"
          className={classNames(
            "duration-20 group flex min-h-10 w-full items-center justify-between space-x-1 rounded px-3 transition-all hover:text-leftNavTextColor md:text-base",
            data._id === group_id || data.slug === group_id || data.submenu.some((item) => `${window.location.origin}${item.link}` === window.location.href)
              ? !mordernDesign && data?.headerMenu
                ? "!bg-headerMenuActiveBgColor !text-headerMenuActiveTextColor"
                : "!bg-leftNavActiveColor !text-leftNavActiveTextColor"
              : !mordernDesign && data?.headerMenu
                ? " text-headerTextColor"
                : "text-leftNavTextColor",
            !mordernDesign && data?.headerMenu ? "group-hover/item:!bg-headerMenuActiveBgColor group-hover/item:!text-headerMenuActiveTextColor" : "",
            windowWidth > 1279 ? "group-hover/item:!bg-leftNavActiveColor group-hover/item:!text-leftNavActiveTextColor" : "",
          )}
          onClick={clickMainMenu}>
          <div className="flex items-center">
            {data.image && (
              <div className={classNames("nav-icon mr-2 h-5 w-5 flex-shrink-0 flex-grow-0", imageClassName)}>
                {isSVGString(data.image) ? (
                  <div dangerouslySetInnerHTML={{ __html: data.image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"') }} />
                ) : (
                  <Image
                    src={data.image}
                    alt={"Menu image"}
                    classes={imageClassName}
                    onError={() => setImageClassName("hidden")}
                  />
                )}
              </div>
            )}
            <div className={classNames("flex flex-shrink flex-grow items-center text-left font-medium", data.type === "group" && data.submenu[0].type === "internal" ? "" : "", isUnderLine && !avoidUnderlineHover ? "group-hover:underline" : "", data?.headerMenu ? "text-sm" : "")}>
              {data.submenu.length > 1 || data.subMenuFilteredDown ? data.name : data.submenu[0].name}
            </div>
          </div>
          <ChevronDownIcon className={classNames("h-7 w-7 rounded-md stroke-2 p-1 md:h-6 md:w-6", windowWidth > 1279 ? "group-hover/item:-rotate-0" : "", dropdownArrowClass)} />
        </button>
      ) : (
        <>
          <TopMenuItemLink
            handleClick={handleClick}
            data={data.submenu[0]}
            group_id={group_id}
            image={data?.image}
            page_id={page_id}
            searchTerm={searchTerm}
            isTopLevel={true}
          />
        </>
      )}
    </>
  );
};

export default TopMenuItemGroupTitle;
